<form [formGroup]="form">
  <div class="card">
    <div class="card-header heading">
      <span class="icon-auto margin-right-10"></span>
      <span data-cy="outOfPocketCoveragesHeader">Coverage for your {{ vehicleDesc }}</span>
    </div>
    <div class="pad-bottom-10 pad-left-5">
      @for (coverage of coverages | formatcoverages: state : isPartner; track coverage) {
        <div>
          @if (coverage?.hasTerms && coverage?.terms[0]?.options.length > 1) {
            <div class="pad-horizontal-10 pad-vertical-20">
              <div class="flex">
                <h2 class="coverage-heading flex-1">{{ coverage.name }}</h2>
                <ds-clicktip-icon
                  class="margin-top-10 margin-right-5"
                  ariaDescribedBy="{{ coverage.name }}"
                  [clicktipRef]="showCoverageInfo"
                ></ds-clicktip-icon>
              </div>
              <ds-clicktip
                #showCoverageInfo
                label="{{ coverage.coverageCategoryCode }}"
                text="{{
                  copyService.getCopy(
                    'policy.changeCoverage.helperInfo.' + coverage.publicID + '.tooltip'
                  )
                }}"
              ></ds-clicktip>
              <div class="pad-vertical-5">
                @for (term of coverage.terms; track $index) {
                  <ds-form-control-container
                    [control]="form.controls[coverage?.publicID + term.name]"
                    [labelText]="
                      form.controls[coverage?.publicID + term.name].value
                        ? ''
                        : 'Please select an option'
                    "
                  >
                    <select
                      class="icon fill"
                      [formControlName]="coverage.publicID + term.name"
                      [attr.data-cy]="term.name + 'Select' | camelCase"
                      (change)="
                        updateCoverages(this.selectedId, coverage, term, null, $event.target.value)
                      "
                    >
                      @for (option of term.options; track option) {
                        <option [value]="option.name">
                          {{ option.formattedName }}
                        </option>
                      }
                    </select>
                    <span class="icon-chevron-down"></span>
                  </ds-form-control-container>
                  @if (term.helpText?.length > 0) {
                    @for (text of term.helpText; track $index) {
                      <p class="font-size-0-75 pad-vertical-5" [innerHTML]="text"></p>
                    }
                  }
                }
              </div>
            </div>
          }
          @if (
            !coverage.hide &&
            (!coverage?.hasTerms ||
              (coverage?.hasTerms && coverage?.terms[0]?.options?.length === 1))
          ) {
            <div class="pad-horizontal-10 pad-vertical-20 checkbox-container">
              <div class="flex">
                <h2 class="coverage-heading flex-1">{{ coverage.name }}</h2>
                <ds-clicktip-icon
                  class="margin-right-5"
                  ariaDescribedBy="{{ coverage.publicID }}"
                  [clicktipRef]="showCoverageInfo"
                ></ds-clicktip-icon>
              </div>
              <ds-clicktip
                #showCoverageInfo
                label="{{ coverage.publicID }}"
                text="{{
                  copyService.getCopy(
                    'policy.changeCoverage.helperInfo.' + coverage.publicID + '.tooltip'
                  )
                }}"
              ></ds-clicktip>
              <div
                class="flex control-border items-center"
                tabindex="0"
                (click)="
                  updateCoverages(
                    this.selectedId,
                    coverage,
                    undefined,
                    !coverage.selected,
                    undefined
                  )
                "
                [ngClass]="
                  coverage?.publicID === 'PAEmergencyRoadServiceCov_af' && coverage?.isDisabled
                    ? 'disabled'
                    : ''
                "
              >
                <input
                  class="checkbox"
                  type="checkbox"
                  [value]="coverage.selected"
                  [id]="coverage.publicID"
                  [formControlName]="coverage.publicID"
                  (change)="
                    updateCoverages(
                      this.selectedId,
                      coverage,
                      undefined,
                      !coverage.selected,
                      undefined
                    )
                  "
                />
                <label
                  class="checkbox-label margin-right-10"
                  [ngClass]="
                    coverage?.publicID === 'PAEmergencyRoadServiceCov_af' && coverage?.isDisabled
                      ? 'checkbox-labeldisabled'
                      : ''
                  "
                ></label>
                Include Coverage
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>
</form>
